import { defineMessages } from 'react-intl';

export const messages: {
	assetsDisplayNameSearchWarning: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	assetsDisplayNameSearchWarning: {
		id: 'search_dialog_assets_display_name_search_warning',
		defaultMessage: '<b>Search by display name is coming soon.</b> Try searching by name.',
		description:
			'Warning banner shown in the global search dialog on Assets routes to inform users that display name search is not yet supported during EAP.',
	},
});
